import axios from "../utils/request";

export function getActiveCampaigns(data) {
  // console.log("come2", data);
  return axios({
    url: `/api/v1/partner-campaigns/admin/list/true`,
    method: "get",
    params: data,
  });
}

export function getDeactiveCampaigns(data) {
  // console.log("come2", data);
  return axios({
    url: `/api/v1/partner-campaigns/admin/list/false`,
    method: "get",
    params: data,
  });
}

export function getCampaigns(data, isActive) {
  console.log("isActive", isActive);
  return axios({
    url: `/api/v1/partner-campaigns/admin/list/${isActive}`,
    method: "get",
    params: data,
  });
}

export function addCampaign(data) {
  return axios({
    url: `/api/v1/partner-campaigns`,
    method: "post",
    data,
  });
}

export function updateCampaignById(data) {
  return axios({
    url: `/api/v1/partner-campaigns`,
    method: "put",
    data,
  });
}

export function delCampaignById(data) {
  return axios({
    url: `/api/v1/partner-campaigns/admin/${data}`,
    method: "delete",
  });
}

export function getCampaignById(data) {
  return axios({
    url: `/api/v1/partner-campaigns/admin/${data}`,
    method: "get",
  });
}
